export enum ResourceTabs {
  mp3 = 'mp3',
  qtool = 'qtool',
  flashcards = 'flashcards',
}

export const QUESTION_ESTIMATE = 90; // sec
